<!--  -->
<template>
    <div class="row-info" :style="styleBox">
        <el-descriptions :column="3" border>
            <el-descriptions-item :labelStyle="labelStyle" :contentStyle="contentStyle" v-for="(item, key) in data"
                :key="key + new Date().getTime()">
                <template slot="label">{{ item.label }}</template>
                {{ item.count }} {{ item.unit }}
            </el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
export default {
    //import引入的组件需要注入到对象中才能使用
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        labelStyle: {
            type: Object,
            default: () => ({ "text-align": "center", "font-weight": "bold" })
        },
        contentStyle: {
            type: Object,
            default: () => ({
                color: "#444",
                "font-weight": "bold",
                "min-width": "200px"
            })
        },
        styleBox: {
            type: Object,
            default: () => ({})
        }
    },
    components: {},
    data() {
        //这里存放数据
        return {

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类</style>